/**
 * What a HOST of the OEM web components knows, and nothing more.
 *
 * String literals rather than imports: the element arrives at runtime from `load.js`, so there
 * is no module in this repo to import it from — and importing one would put a second copy of
 * the domain on the page, which is the whole thing loading it remotely avoids.
 *
 * NO ATTRIBUTE CONSTANTS. The element observes no attributes at all: its environment, its API
 * base URL and its build version are compiled into the bundle, and one bundle is published per
 * environment. A host cannot point it at the wrong environment because there is nothing to
 * point.
 */

/** Registered by the bundle behind `config.oemComplianceLoaderUrl`. */
export const SI_OEM_COMPLIANCE_TAG = "si-oem-compliance";

/** Raised when the element wants the host to change view. Only relevant to a host that also
 * sets `view`/`params`/`hrefFor`, which this one deliberately does not — the element then owns
 * its own navigation. */
export const SI_NAVIGATE_EVENT = "si-navigate";

/** Raised when the service refuses the token: the host owns the session, so ending it is the
 * host's move. Both element events are `bubbles` + `composed`, so they cross the shadow root. */
export const SI_SESSION_ENDED_EVENT = "si-session-ended";

export interface OemSessionUser {
  subject: string;
  displayName: string;
  roles: readonly string[];
  brandScopes: readonly string[];
}

/**
 * Handed to the element as a PROPERTY and never as an attribute, so the bearer token is never
 * serialized into the DOM, `outerHTML` or a snapshot.
 */
export interface OemSession {
  token: string;
  user: OemSessionUser;
}
